import React, { useState } from 'react'
import './LeftBar.scss'
import { useSelector, useDispatch } from 'react-redux';
import { leftBarClicked, searchBarClicked, filterBarClicked } from '../redux/actions/index';
import { ReactComponent as BackspaceIcon } from "../assets/svg/leftBar/backspace.svg";
import { ReactComponent as FilterIcon } from "../assets/svg/leftBar/filter.svg";
import { ReactComponent as PlusIcon } from "../assets/svg/leftBar/plus.svg";
import { ReactComponent as RefreshIcon } from "../assets/svg/leftBar/refresh.svg";
import { ReactComponent as SearchIcon } from "../assets/svg/leftBar/search.svg";
import { ReactComponent as TrashbinIcon } from "../assets/svg/leftBar/trashbin.svg";
import { ReactComponent as RightwardIcon } from "../assets/svg/leftBar/rightward.svg";

function LeftBarTemp(props) {
    const leftBarData = props.leftBarData;
    const [inputValue, setInputValue] = useState({})
    const topTapData = useSelector(state => state.topTab)
    const leftTab = useSelector(state => state.leftTab)
    const dispatch = useDispatch()
    const leftBarClickeD = () => {
        dispatch(leftBarClicked());
    }
    const searchBarClickeD = () => {
        dispatch(searchBarClicked());
    }
    const filterBarClickeD = () => {
        dispatch(filterBarClicked());
    }
    return (
        <div className='LeftBar'>
            <div className='title-top'>
                <p className='topTitle'>{topTapData?.items[topTapData.nowId - 1]?.name}</p>
                <div className='right-icons'>
                    <PlusIcon />
                    <RefreshIcon />
                    <RightwardIcon className='rotate-anti-clockwise' />
                </div>
            </div>
            <div className='title-second'>
                <p className='topTitle'>Numero risultati</p>
                <div className='right-icons'>
                    <p>###</p>
                    <RightwardIcon className={leftTab?.flag ? 'rotate-anti-clockwise' : 'rotate-clockwise'} onClick={leftBarClickeD} />
                </div>
            </div>
            <div className={leftTab.flag ? '' : 'hidden'}>
                <div className='side-panel'>
                    <div className='inter-line'></div>
                    <div className='title'>
                        <div className='left'>
                            <SearchIcon />
                            <p>Ricerca</p>
                        </div>
                        <div className='right'>
                            <BackspaceIcon />
                            <RightwardIcon className={leftTab?.searchTab?.flag ? 'rotate-anti-clockwise' : 'rotate-clockwise'} onClick={searchBarClickeD} />
                        </div>
                    </div>
                    <div className={leftTab?.searchTab?.flag ? '' : 'hidden'}>
                        <div className="search-items scroll">
                            {
                                leftBarData?.searchPanel?.map((item, index) => {
                                    return (
                                        <div className='item' key={"searchPanelItem" + index}>
                                            <p>{item}</p>
                                            <div className='search-box'>
                                                <input type="text" name={index}
                                                value={inputValue[index] || ''}
                                                onChange={(e)=>{
                                                    setInputValue(prevState => {
                                                        return { ...prevState, [index]: e.target.value }
                                                    })
                                                }}
                                                />
                                                <div className='right'>
                                                    <SearchIcon />
                                                    <TrashbinIcon
                                                    onClick={()=>{
                                                        setInputValue(prevState => {
                                                            return { ...prevState, [index]: '' }
                                                        })
                                                    }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className='buttons'>
                            <div className='left'>
                                <p>PULISCI</p>
                            </div>
                            <div className='right'>
                                <p>CERCA</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='side-panel'>
                    <div className='inter-line'></div>
                    <div className='title'>
                        <div className='left'>
                            <FilterIcon />
                            <p>Filtri</p>
                        </div>
                        <div className='right'>
                            <RightwardIcon className={leftTab?.filterTab?.flag ? 'rotate-anti-clockwise' : 'rotate-clockwise'} onClick={filterBarClickeD} />
                        </div>
                    </div>
                    <div className={leftTab?.filterTab?.flag ? 'filter-items scroll' : 'hidden'}>
                        {
                            leftBarData?.filterPanel?.map((item, index) => {
                                return (
                                    <div className='item' key={"filterPanelItem" + index}>
                                        <p>{item?.title}</p>
                                        {
                                            item?.items?.map((iitem, iindex) => {
                                                return (
                                                    <div className='check-box' key={"filterPanelItem" + index + "-" + iindex}>
                                                        <input type="checkbox" defaultChecked={false} />
                                                        <p>{iitem}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                        <div className='space'></div>
                    </div>
                </div>
                <div className='space'></div>
            </div>
        </div>
    )
}

export default LeftBarTemp
